import { createEntityAdapter } from "@reduxjs/toolkit";
import apiSlice from "../api/apiSlice";

// Create an entity adapter
const sizingGeneralParametersAdapter = createEntityAdapter({});

// Create the API slice
export const generalParametersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /* GET */
    getGeneralParametersByCommunityId: builder.query({
      query: ({ communityId }) => ({
        url: `/communities/${communityId}/sizing_general_parameters`,
        method: "GET",
        validateStatus: (response, result) => response.status === 200 && !result.isError,
      }),
      transformResponse: (responseData) => responseData,

      providesTags: (result) => {
        if (result?.id) {
          return [
            { type: "SizingGeneralParameter", id: "LIST" },
            { type: "SizingGeneralParameter", id: result.id },
          ];
        }
        return [{ type: "SizingGeneralParameter", id: "LIST" }];
      },
    }),
    /* POST */
    addNewGeneralParameter: builder.mutation({
      query: (parameter) => ({
        url: `/communities/${parameter.community_id}/sizing_general_parameters`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Include Authorization or any other required headers
        },
        body: {
          ...parameter,
        },
      }),
      invalidatesTags: [{ type: "SizingGeneralParameter", id: "LIST" }],
    }),
    /* UPDATE */
    updateGeneralParameterById: builder.mutation({
      query: ({ communityId, parameterId, updatedData }) => ({
        url: `/communities/${communityId}/sizing_general_parameters/${parameterId}`,
        method: "PUT",
        body: {
          ...updatedData,
        },
      }),
      invalidatesTags: (_, __, arg) => [{ type: "SizingGeneralParameter", id: arg.parameterId }],
    }),
  }),
});

// Export hooks for the component
export const {
  useGetGeneralParametersByCommunityIdQuery,
  useAddNewGeneralParameterMutation,
  useUpdateGeneralParameterByIdMutation,
} = generalParametersApiSlice;

export const { selectAll: selectAllGeneralParameters } =
  sizingGeneralParametersAdapter.getSelectors();
